import { TReview } from 'types/review';

import { CRMAPIBase } from '@api/crmApiBase';
import { RequestResult } from '@api/responseModels/requestResult';
import { ReviewListResp } from '@api/responseModels/review/reviewListResponse';

class ReviewGroup extends CRMAPIBase {
    async getReviewList({ crm_id }): Promise<RequestResult<ReviewListResp>> {
        const result = await this.get<ReviewListResp>(`/reviews`, {
            crm_id,
        });
        return result;
    }

    async createReview(params: TReview): Promise<RequestResult<ReviewListResp>> {
        const result = await this.post<ReviewListResp>('/reviews', params);
        return result;
    }

    async updateReview(params: TReview): Promise<RequestResult<ReviewListResp>> {
        const result = await this.put<ReviewListResp>(`/reviews/${params.id}`, params);
        return result;
    }

    async deleteReview(params: {
        id: number;
        crmId: number;
    }): Promise<RequestResult<ReviewListResp>> {
        const result = await this.delete<ReviewListResp>(`/reviews/${params.id}`, {
            crm_id: params.crmId,
        });
        return result;
    }
    async approvedReview(params: {
        review_id: number;
        crm_id: number;
    }): Promise<RequestResult<ReviewListResp>> {
        const result = await this.post<ReviewListResp>(`/reviews/approved`, params);
        return result;
    }
}

export { ReviewGroup };
